import { useEffect } from 'react';
import { textDimensions } from '../utils';
const TEST_HEIGHT = '+1234567890';
export function useTicks(scale, direction, ref, options) {
    const range = scale.range();
    if (!range)
        throw new Error('Range needs to be specified');
    const domain = scale.domain();
    if (!domain)
        throw new Error('Domain needs to be specified');
    const { minSpace = 8, tickFormat, setTicks } = options;
    const axisLength = Math.abs(range[0] - range[1]);
    // Calculates the tick number that fits in the given space
    useEffect(() => {
        if (ref.current) {
            let tickNumber;
            let ticks = [];
            if (direction === 'horizontal') {
                while (true) {
                    // get next ticks
                    ticks = scale.ticks(tickNumber);
                    const formatedTicks = ticks.map(tickFormat);
                    tickNumber = Math.min(ticks.length, tickNumber || Infinity);
                    // get the current tick space
                    const { width } = textDimensions(formatedTicks.join(''), ref);
                    const size = width + (ticks.length - 1) * minSpace;
                    // repeats if the size is bigger than current space
                    if (size > axisLength && tickNumber > 1) {
                        tickNumber = tickNumber - 1;
                    }
                    else {
                        break;
                    }
                }
            }
            else {
                const { height } = textDimensions(TEST_HEIGHT, ref);
                while (true) {
                    // get next ticks
                    ticks = scale.ticks(tickNumber);
                    tickNumber = Math.min(ticks.length, tickNumber || Infinity);
                    // get the current tick space
                    const size = ticks.length * (height + minSpace) - minSpace;
                    // repeats if the size is bigger than current space
                    if (size > axisLength && tickNumber > 1) {
                        tickNumber = tickNumber - 1;
                    }
                    else {
                        break;
                    }
                }
            }
            setTicks(ticks.map((value) => ({
                label: tickFormat(value),
                position: scale(value),
                value,
            })));
        }
    }, [axisLength, direction, minSpace, ref, scale, setTicks, tickFormat]);
}
//# sourceMappingURL=useTick.js.map